const Layout = () => import('@/layout/index.vue');
import uSvg from '@/assets/svg/u.svg';

export default {
  path: '/Config_show',
  name: 'Config_show',
  component: Layout,
  meta: {
    icon: 'tools',
    title: '对账数据',
    rank: 3,
    permission: ['root', 'common']
  },
  children: [
    {
      path: '/u_show',
      name: 'u_show',
      component: () => import('@/views/config/u_show/index.vue'),
      meta: {
        icon: uSvg,
        iconType: 'svg',
        title: '对账详情'
      }
    }
  ]
};
